import { ShareInfo } from 'api';
import {
    initCookieConsent,
    InitPotreeTemplate,
    potreeRenderPreparations,
} from 'utils';

interface ShareUrlOptions {
    is_embed: boolean;
    is_clean: boolean;
}

export function handleShareInfoSuccess(shareInfo: ShareInfo) {
    const urlShareParams = getShareOptions();
    const { is_embed, is_clean } = urlShareParams;
    uiElementsConfiguration(urlShareParams);

    potreeRenderPreparations(shareInfo);

    const args = {
        prj_id: shareInfo.prj_id,
        prj_name: shareInfo.prj_name,
        prj_token: shareInfo.prj_token,
        prj_storg_name: shareInfo.prj_storg_name,
        prj_path: shareInfo.prj_path,
        dataset_id: shareInfo.dataset_id,
        share_id: shareInfo.share_id,
        share_token: shareInfo.share_token,
        permission: shareInfo.permission,
        org_id: shareInfo.org_id,
        team_id: shareInfo.team_id,
        org_style: shareInfo.org_style,
        is_embed,
        is_clean,
        org_name: shareInfo.org_name,
        org_website: shareInfo.org_website,
        copyright_date: new Date().getFullYear(),
        watermark: shareInfo.watermark,
        watermark_text: shareInfo.watermark_text,
        enable_orthofile: shareInfo.enable_orthofile,
    };

    const defMenuMainColor = '#bfd730';
    const defMenuLightColor = '#aec523';
    const defMenuTextColor = 'gray';
    const defMenuSidbarBGColor = 'rgba(77,78,80,1)';

    if (args.org_style) {
        const orgAppearance = JSON.parse(args.org_style);

        const orgColor = orgAppearance ? orgAppearance.color : null;
        document.documentElement.style.setProperty(
            '--main-color',
            orgColor.menu_main ? orgColor.menu_main : defMenuMainColor
        );
        document.documentElement.style.setProperty(
            '--light-color',
            orgColor.menu_light ? orgColor.menu_light : defMenuLightColor
        );
        document.documentElement.style.setProperty(
            '--text-color',
            orgColor.menu_text ? orgColor.menu_text : defMenuTextColor
        );
        document.documentElement.style.setProperty(
            '--sidbar-bg-color',
            orgColor.sidbar_menu_bg
                ? orgColor.sidbar_menu_bg
                : defMenuSidbarBGColor
        );
    } else {
        document.documentElement.style.setProperty(
            '--main-color',
            defMenuMainColor
        );
        document.documentElement.style.setProperty(
            '--light-color',
            defMenuLightColor
        );
        document.documentElement.style.setProperty(
            '--text-color',
            defMenuTextColor
        );
        document.documentElement.style.setProperty(
            '--sidbar-bg-color',
            defMenuSidbarBGColor
        );
    }

    const { permissions } = InitPotreeTemplate(args as any);

    return { permissions };
}

function getShareOptions(): ShareUrlOptions {
    const embedUrlKey = 'embed';
    const cleanUrlKey = 'clean';

    const urlParams = new URLSearchParams(window.location.search);
    const params = Object.keys(Object.fromEntries(urlParams.entries()));

    const is_embed = params.includes(embedUrlKey);
    const is_clean = params.includes(cleanUrlKey);

    return {
        is_embed,
        is_clean,
    };
}

function uiElementsConfiguration({ is_embed }: ShareUrlOptions) {
    if (is_embed) {
        $('#embed_fullscreen')[0].href =
            window.location.origin + window.location.pathname;
        $('#embed_fullscreen')[0].style.display = 'inline';

        const searchPart = window.location.search.replace(/&?embed&?/, '');

        $('#embed_fullscreen')[0].href =
            window.location.origin + window.location.pathname + searchPart;
        $('#embed_fullscreen')[0].style.display = 'inline';
    } else {
        /* SHOW COOKIE CONSENT */
        initCookieConsent();
    }
}
